export default () => {
  const files = require.context("./", true, /\.js$/);
  const api = {};
  files.keys().forEach((key) => {
    const name = key.replace(/(\.\/|\.js)/g, "");
    if (name !== "index") {
      const parts = name.split("/");
      const prefix = parts[0];
      const value = parts[1];
      if (!api[prefix]) api[prefix] = {};
      api[prefix][value] = files(key).default;
    }
  });
  return api;
};
